module.exports = __webpack_public_path__ + "img/CCLF_infographic-01.bffaeb3b.png";